<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodaj proces dla komponentu: <strong>{{ component.component.name }}({{ component.component.code }})</strong>
                </h1>
            </v-card-title>

            <v-card-text>
                <v-autocomplete
                    v-model="selectedProcesses"
                    :items="filteredProductionProcesses"
                    :search-input.sync="search"
                    label="Procesy produkcyjne:"
                    placeholder="Wybierz procesy produkcyjne"
                    item-value="id"
                    item-text="name"
                    return-object
                    chips
                    clearable
                    outlined
                    multiple
                    hide-details
                    @change="search = null"
                >
                    <template #selection="{item}">
                        <v-chip
                            close
                            @update:active="removeProcess(item)"
                        >
                            {{ item.name }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onCancel"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="selectedProcesses.length === 0"
                    @click="onSave"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { orderBy } from 'lodash'
export default {
    name: 'AssignProductionProcessesDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        component: {
            type: Object,
            default: null
        },
        processes: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            selectedProcesses: [],
            isSaved: false,
            search: null,
        }
    },
    computed: {
        filteredProductionProcesses() {
            const componentProcesses = this.component.productTypeComponentProcesses || this.component.orderComponentProcesses || this.component.campaignComponentProcesses

            const processesList = this.processes || []
            const processes = processesList.filter(productionProcess => {
                return !componentProcesses.some(productTypeComponentProcess => {
                    return productTypeComponentProcess.productionProcessId === productionProcess.id
                })
            })

            return orderBy(processes, 'name', 'asc')
        }
    },
    methods: {
        removeProcess(item) {
            this.selectedProcesses.splice(this.selectedProcesses.indexOf(item), 1)
        },
        onSave() {
            this.$emit('on-save', this.selectedProcesses)
            this.isSaved = true
            this.onClose()
        },
        onClose() {
            if (this.selectedProcesses.length > 0 && !this.isSaved) {
                this.$emit('on-save', this.selectedProcesses)
            }
            this.resetData()
            this.$emit('on-close')
        },
        onCancel() {
            this.resetData()
            this.$emit('on-close')
        },
        resetData() {
            this.selectedProcesses = []
            this.isSaved = false
        }
    }
}
</script>
